(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["xtra-canada-tax-labels"] && !Shopify.designMode) return;
  try {
    (() => {
    const countryCode = document.documentElement.dataset.countryCode;
    if (countryCode !== 'CA' && countryCode !== 'US') return;
    const badgeSelector = 'product-gallery .product-gallery__media > [id]';
    const taxMessage = 'no sales tax collected outside california';

    function hideTaxLabels(root) {
      const element = root.nodeType === 1 ? root : root.parentElement;
      const candidates = new Set();
      const ancestor = element?.closest?.(badgeSelector);
      if (ancestor) candidates.add(ancestor);
      root.querySelectorAll?.(badgeSelector).forEach((badge) => candidates.add(badge));
      for (const badge of candidates) {
        const isTaxLabel = badge.textContent.replace(/\s+/g, ' ').trim().toLowerCase() === taxMessage;
        const shouldHide = countryCode === 'CA' && isTaxLabel;
        if (badge.hasAttribute('data-xtra-app-tax-label') !== isTaxLabel) {
          badge.toggleAttribute('data-xtra-app-tax-label', isTaxLabel);
        }
        if (badge.hasAttribute('data-xtra-hidden-tax-label') !== shouldHide) {
          badge.toggleAttribute('data-xtra-hidden-tax-label', shouldHide);
        }
      }
    }

    function observeTaxLabels() {
      hideTaxLabels(document);
      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          hideTaxLabels(mutation.target);
          for (const node of mutation.addedNodes) hideTaxLabels(node);
        }
      });
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeTaxLabels, { once: true });
    } else {
      observeTaxLabels();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
